import { IconWrapper } from '../runtime';
export default IconWrapper('keyboard', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M5 9.74976H11M5 6.74979H5.25M7.76953 6.74979H8.26953M10.75 6.74979H11M3.25 13.2498H12.75C13.5784 13.2498 14.25 12.5782 14.25 11.7498V4.24976C14.25 3.42133 13.5784 2.74976 12.75 2.74976H3.25C2.42157 2.74976 1.75 3.42133 1.75 4.24976V11.7498C1.75 12.5782 2.42157 13.2498 3.25 13.2498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});